import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Briefcase, Mail, ArrowLeft, CheckCircle2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await axios.post(`${API}/auth/forgot-password`, { email }, { withCredentials: true });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to send reset email');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/auth" className="inline-flex items-center gap-2 text-[#047857] mb-8 hover:opacity-80"><ArrowLeft size={18} strokeWidth={1.5} /> Back to login</Link>
        <div className="bg-white rounded-3xl border border-[#E5E0D8] shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-[#047857] flex items-center justify-center">
              <Briefcase size={18} className="text-white" strokeWidth={1.5} />
            </div>
            <h1 className="text-2xl font-medium tracking-tight" style={{fontFamily:'Outfit'}}>Reset Password</h1>
          </div>
          {sent ? (
            <div className="text-center py-6" data-testid="reset-sent">
              <CheckCircle2 size={48} className="text-[#047857] mx-auto mb-4" strokeWidth={1.5} />
              <h2 className="text-lg font-medium mb-2" style={{fontFamily:'Outfit'}}>Check Your Email</h2>
              <p className="text-[#1C2A24]/60 text-sm">If an account exists with that email, we've sent a password reset link. Check your inbox and spam folder.</p>
              <Link to="/auth"><Button className="rounded-full bg-[#047857] hover:bg-[#065F46] text-white mt-6" data-testid="back-to-login-btn">Back to Login</Button></Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <p className="text-sm text-[#1C2A24]/60 mb-4">Enter your email address and we'll send you a link to reset your password.</p>
              <div>
                <Label className="text-sm text-[#1C2A24]/70">Email</Label>
                <div className="relative mt-1">
                  <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#1C2A24]/40" strokeWidth={1.5} />
                  <Input data-testid="forgot-email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="pl-10 rounded-2xl bg-[#F4F1E8] border-[#E5E0D8] h-12" placeholder="your@email.com" required />
                </div>
              </div>
              {error && <div className="bg-red-50 text-red-700 px-4 py-3 rounded-2xl text-sm" data-testid="forgot-error">{error}</div>}
              <Button data-testid="send-reset-btn" type="submit" disabled={loading} className="w-full h-12 rounded-full bg-[#047857] hover:bg-[#065F46] text-white font-medium">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
